const drawer = {
  root: {
    content: {
      padding: '{spacing.xs} {spacing.m}',
    },
    margin: 0,
    maxHeight: '100%',
    background: '{white}',
    shadow: '0 0 19px 0 rgba(0, 0, 0, 0.75)',
    zIndex: '{zindex.drawer}',
    borderRadius: '0',
  },
  header: {
    borderBottom: '1px solid {gray.scale.300}',
    padding: '0px {spacing.m}',
    row: {
      padding: '10px {spacing.m}',
    },
  },
  footer: {
    shadow: '24px 27px 52px 7px rgba(0, 0, 0, 0.25)',
    padding: '20px',
  },
  quiticon: {
    x: {
      icon: {
        width: '17px',
        height: '17px',
        color: '{gray.scale.600}',
      },
      container: {
        right: '10px',
        top: '10px',
        padding: '0',
      },
    },
    back: {
      container: {
        height: '90px',
        margin: '0 20px',
        background: 'linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 1) 75%, rgba(255, 255, 255, 0) 100%)',
        width: 'calc(100% - 7px - 0.5rem)',
        zIndex: '1',
        left: '-20px',
      },
      icon: {
        color: '{primary.color}',
        margin: '{spacing.m} 0 0 0',
        width: '36px',
        height: '25px',
        hover: {
          color: '#1d5c8f',
        },
      },

    },
  },
};

export default drawer;
// # sourceMappingURL=index.mjs.map
